import { z } from "zod";

/** POST /api/v1/auth/telegram — body carries the RAW, unparsed initData string. */
export const authTelegramRequestSchema = z.object({
  initData: z.string().min(1).max(4096),
});

export type AuthTelegramRequest = z.infer<typeof authTelegramRequestSchema>;

export const authTelegramResponseSchema = z.object({
  userId: z.string(),
  isNewUser: z.boolean(),
  /** Bearer token for `Authorization: Bearer <token>` on subsequent requests. */
  token: z.string(),
});

export type AuthTelegramResponse = z.infer<typeof authTelegramResponseSchema>;
